import React from 'react';
import { showDateNoTime, calculateAge } from 'utils/NwMoment';

const getAdditionalInfo = (model, clientConfig) => {
    const modelConfig = (clientConfig && clientConfig.model) || {};
    return {
        showBirthDate: Boolean(model && modelConfig.showBirthDate && model.BirthDate),
        showAge: Boolean(model && modelConfig.showAge && model.BirthDate && calculateAge(model.BirthDate)),
        //un oggetto vuoto è truthy: senza contare le chiavi risulterebbe sempre che ci sono custom fields
        hasCustomFields: Boolean(model && model.CustomFields && Object.keys(model.CustomFields).length),
    };
};

const hasAdditionalInfo = (model, clientConfig) => {
    const { showBirthDate, showAge, hasCustomFields } = getAdditionalInfo(model, clientConfig);
    return showBirthDate || showAge || hasCustomFields;
};

const ModelAdditionalInfo = ({ model, clientConfig, onClick }) => {
    const { showBirthDate, showAge, hasCustomFields } = getAdditionalInfo(model, clientConfig);

    if (!showBirthDate && !showAge && !hasCustomFields) {
        return null;
    }

    return (
        <div className="model-additional-info" onClick={onClick}>
            {showBirthDate &&
                <div className="model-birthdate">
                    <span className="model-birthdate-name">Birthdate</span>
                    <span className="model-birthdate-value">
                        {showDateNoTime(model.BirthDate)}
                    </span>
                </div>
            }
            {showAge &&
                <div className="model-age">
                    <span className="model-age-name">Age</span>
                    <span className="model-age-value">
                        {calculateAge(model.BirthDate)}
                    </span>
                </div>
            }
            {hasCustomFields &&
                Object.keys(model.CustomFields).map((key, index) => (
                    <div className="model-customfield" key={`customfields-${index}`}>
                        <span className="model-customfield-name">{key.replace(/_/g, ' ')}</span>
                        <span className="model-customfield-value">
                            {model.CustomFields[key]}
                        </span>
                    </div>
                ))
            }
        </div>
    );
};

export { hasAdditionalInfo };
export default ModelAdditionalInfo;
